import styled from 'styled-components';

export const TagContainer = styled.div`
  max-width: 16rem;
  background: #66cc00;
  color: #1f3d00;
  font-weight: 900;
  padding: 0.5rem;
  border-radius: 5px;
  font-size: 13px;
  margin: 0.5rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1300px) {
    font-size: 85%;
  }

  @media (max-width: 1100px) {
    flex-direction: row;
    font-size: 100%;
  }
`;

export const CloseButton = styled.button`
  margin-left: 2rem;
  border: 0;
  background: transparent;
`;
